import list from "@/modules/company/stores/department/department_list.store";
import form from "@/modules/company/stores/department/department_form.store";

export default {
  // company.department
  modules: { list, form },
};
